"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStorePath = void 0;
var getStorePath = function (department, category, productName) {
    var path = '/store/' + department + '/';
    if (category)
        path += category + '/';
    if (productName)
        path += productName;
    return path;
};
exports.getStorePath = getStorePath;
